<template>
    <main class="page customers">

        <section class="auto start background-dark">
            <div class="inner">
                <div class="title large">
                    <h1>Amazing product teams around the world <span class="highlight">trust Sleekpan</span></h1>
                </div>
                <img src="/assets/pages/customers/illustration.svg" class="background-image">
            </div>
        </section>

        <section class="light round second">

            <div class="testimonials-outer">
                <div class="testimonials-grid">
                    <div class="testimonial-cards-column" v-for="(testimonial_chunk, key) in loaded_testimonials" v-bind:key="key">
                        <div class="testimonial-card" v-for="(testimonial, key) in testimonial_chunk" v-bind:key="key">
                            <div class="testimonial-card-inner">
                                <div class="testimonial-header">
                                    <div class="image">
                                        <img v-if="testimonial.reviewer_picture_url" :src="testimonial.reviewer_picture_url">
                                        <div v-else>
                                            <span>{{testimonial.reviewer_name.charAt(0).toUpperCase()}}</span>
                                        </div>
                                    </div>
                                    <div class="name">{{testimonial.reviewer_name}}</div>
                                    <div class="source">
                                        <svg v-if="testimonial.supplier == 'capterra'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M14.292 11.091V23l-4.72-11.909h4.72zM21 3l-5.907 18.844V5.217L21 3zM8.772 11.091l1.215 3.056L1 11.09h7.772zm5.52-5.51v4.705H1.801l12.491-4.704z"></path></svg>
                                        <svg v-if="testimonial.supplier == 'g2'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12.294 2a17.06 17.06 0 011.96.192c-.673 1.368-1.337 2.739-2.014 4.104a5.85 5.85 0 00-3.756 1.336 5.699 5.699 0 00-2.015 3.421c-.221 1.382.06 2.846.846 4.022.867 1.35 2.34 2.302 3.946 2.568a6.01 6.01 0 004.805-1.302c.734 1.25 1.471 2.5 2.213 3.745-1.95 1.398-4.42 2.074-6.83 1.882a10.227 10.227 0 01-6.442-2.894 9.852 9.852 0 01-2.896-5.68A18.007 18.007 0 012 11.87v-.32c.068-.677.134-1.359.32-2.016.684-2.675 2.57-5.022 5.057-6.324 1.474-.79 3.15-1.18 4.828-1.21h.09zm7.146 8.639c.826 1.4 1.642 2.803 2.486 4.192l.074.087v.06l-.073.087c-.842 1.397-1.66 2.807-2.497 4.208-.845-1.446-1.704-2.884-2.554-4.326-1.703.001-3.406-.002-5.109.002.848-1.437 1.705-2.868 2.544-4.31 1.71-.004 3.42-.003 5.129 0zm-.304-7.11c.737.642.697 1.883.005 2.542-.566.576-1.382.797-2.047 1.233-.273.17-.427.455-.53.743 1.025.013 2.05.006 3.076.004.005.407.003.814.003 1.222a886.659 886.659 0 00-4.613 0c-.024-.784.098-1.617.59-2.264.482-.632 1.219-1.007 1.931-1.346.32-.164.7-.389.745-.772.051-.28-.124-.565-.39-.674-.431-.18-.949-.102-1.34.138-.295.18-.487.473-.663.758-.291-.285-.583-.57-.88-.848.392-.752 1.206-1.283 2.073-1.344.724-.061 1.5.116 2.04.608z"></path></svg>
                                    </div>
                                </div>
                                <div class="testimonial-content">
                                    <div class="title">{{testimonial.title}}</div>
                                    <div class="text">{{testimonial.text}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div class="inner">

                <div class="stats-box">
                    <div class="item">
                        <div class="value">3X</div>
                        <div class="key">Improvements on NPS over last 12 months</div>
                    </div>
                    <div class="item">
                        <div class="value">98%</div>
                        <div class="key">Would recommend Sleekplan</div>
                    </div>
                    <div class="item">
                        <div class="value">70%</div>
                        <div class="key">WAUs increase over last 12 months</div>
                    </div>
                </div>

            </div>


        </section>


        <section class="white">
            <div class="inner">
                <transition-group 
                    name="logo-fade" 
                    tag="div"
                    v-on:before-enter="fade_before_enter"
                    v-on:enter="fade_enter"
                    v-on:leave="fade_leave"
                    class="logos"
                >
                    <div 
                    class="logo-item" 
                    v-for="(logo, index) in visible_logos" 
                    :key="logo.img" 
                    :data-index="index">
                        <!-- Show the image if available, otherwise show a transparent div as a placeholder -->
                        <img v-if="logo.img" :src="logo.img" />
                        <img v-else src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==">
                    </div>
                </transition-group>

                <div class="section-seperator"></div>
                
                <div class="row preview-box light">
                    <div class="col-xs-12 col-sm-4 preview-content">
                        <div class="preview-content-text content-large">
                            <div class="pre-head">Enterprise & Startups</div>
                            <h2> 
                                <span class="sub">Sleekplan helps</span> Startups and Enterprises
                            </h2>
                            <span>...managing thoushands of feedbacks from internal and external audiences</span>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-8 preview">
                        <div class="preview-image">
                            <img src="/assets/pages/customers/team.jpg">
                        </div>
                    </div>
                </div>
            </div>

            <div style="width: 100%;">
                <div class="elfsight-app-19b533d2-bf7b-409c-863c-5fb012746c85"></div>
            </div>
            
        </section>

        <section class="color end">
            <div class="inner">
                
                <div class="content-large center">
                    <h2>Build Better Products</h2>
                    <span>Powerful, all-in-one product feedback to help you engage, and retain more users.</span>
                    <div class="button-area">
                        <a href="https://app.sleekplan.com/sign-up/" class="btn large uppercase">Get started for free</a>
                        <span class="btn-sub">No credit card required</span>
                    </div>
                </div>
                
            </div>
        </section>

    </main>
</template>

<script>
export default {


    /** ----------------------------------------------------
     * View => Base data
     ----------------------------------------------------- */
    data() {
        
        // data
		return {
            logo_white: require('@/assets/media/logo/logo-white.svg'),
            logo_default: require('@/assets/media/logo/logo.svg'),

            companies: [
                {img: '/assets/testimonials/ooma.svg', height: false},
                {img: '/assets/testimonials/yodeck.svg', height: false},
                {img: '/assets/testimonials/york-u.png', height: false},
                {img: '/assets/testimonials/tunerelease.png', height: false},
                {img: '/assets/testimonials/mercedes.svg', height: false},
                {img: '/assets/testimonials/decathlon.png', height: false},
                {img: '/assets/testimonials/fender.svg', height: false},
                {img: '/assets/testimonials/mck.svg', height: false},
                {img: '/assets/testimonials/n26.png', height: false},
                {img: '/assets/testimonials/lambdatest.png', height: false},
                {img: '/assets/testimonials/material-exchange.svg', height: false},
                {img: '/assets/testimonials/hid.svg', height: false},
                {img: '/assets/testimonials/billbee.png', height: false},
                {img: '/assets/testimonials/dendreo.svg', height: false},
            ],

            visible_logos: [],      // The 4 logos currently visible
            hidden_logos: [],       // The hidden logos
            interval_id: null,      // Interval ID for shuffling logos
            fading_out: false,      // Flag to prevent multiple fadeouts
            replacement_queue: [],  // Queue to ensure all logos are replaced before repeating
            
            testimonials: [
                {
                    "id": 5729205321,
                    "supplier": "capterra",
                    "reviewer_name": "Alex M.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Overall:Set up was very easy - thanks to the automated product tour. Great work Sleekplan!\n :Sleekplan enables me to collect all of my customer suggestions in one place. The feedback is prioritized by popularity through upvoting. This information is very valuable for me to improve my product. Giving my customers a place to provide feedback makes them feel heard.\n :It is a young software (at the time of writing this), but it seems quite robust. Honestly, my use case is fairly simple and I'm really enjoying Sleekplan so far.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Sleekplan is a powerful feedback platform",
                    "language": null,
                    "published_at": 1631145600
                },
                {
                    "id": 5729205305,
                    "supplier": "capterra",
                    "reviewer_name": "Oliver F.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": " :Multiple ways to use the software (widget on website, standalone site, ...).\n :Survey and User-Satisfaction Feedback is nice at this time, but it would be possible to improve :)",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Great solution with a lot of features",
                    "language": null,
                    "published_at": 1631750400
                },
                {
                    "id": 5729205309,
                    "supplier": "capterra",
                    "reviewer_name": "Luke R.",
                    "reviewer_picture_url": "https://cdn0.capterra-static.com/profile-images/linkedin/ecb2aa04509dbd5d3a1b46703994667b.jpeg",
                    "rating": 5,
                    "text": "Overall:Really lovely user experience and customer support.\n :Easy implementation, nice visuals, custom domain integration. Very good.\n :Perhaps some additional tools around what notices to show as a popup to a user and when, but it's really good as it currently is!",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Great user feedback tool",
                    "language": null,
                    "published_at": 1630540800
                },
                {
                    "id": 5729205322,
                    "supplier": "capterra",
                    "reviewer_name": "Verified Reviewer",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Overall:Really impressed. Superb UI/UX makes this a really phenomenal tool for those that need these kind of engagement / interaction tools for their businesses.\n :Love that it provides multiple tools in one place (feedback, roadmap and changelog)\n :The survey aspects of this tool are limited - though I have to be honest and say that I have other specialist tools for this particular function. I don't necessarily need Sleekplan to do everything :)",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Powerful and flexible system to engage with customers",
                    "language": null,
                    "published_at": 1627776000
                },
                {
                    "id": 5729205304,
                    "supplier": "capterra",
                    "reviewer_name": "Tomas S.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Overall:I felt in love immediately after trying this app and now after several months the heart is still beating.\n :Simplicity, features like visual analytics or user segmentation, allo very good price a first class support from the Sleekplan team.\n :Some UX patterns need improvement, but it is fast evolving app listening to its users. I believe its only matter of time to have them incorporated.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Simple and affordable app providing all we need",
                    "language": null,
                    "published_at": 1629849600
                },
                {
                    "id": 5729205313,
                    "supplier": "capterra",
                    "reviewer_name": "Baptiste A.",
                    "reviewer_picture_url": "https://cdn0.capterra-static.com/profile-images/linkedin/eb1bec073750a37e8b05e9778d40705f.jpeg",
                    "rating": 5,
                    "text": " :Ease of deployment. I just had to enter my company details and colors and I could right away share the feedback board with my users.\n :Deactivate specific settings like \"Remove branding\" was a bit tricky to find. But it is no harm.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Perfect product feedback tool",
                    "language": null,
                    "published_at": 1628726400
                },
                {
                    "id": 5729205302,
                    "supplier": "capterra",
                    "reviewer_name": "Kumar M.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Overall:- Awesome customizable tool available, which will help me get user's input very smoothly.\n- Option to use verified user is excellent. Just an otp on email and you are good to go.\n- I was able to capture feedback in just 5 mins. \n[SENSITIVE CONTENT]\n :- Quick Customization\n- Ease of use\n- cname option\n- Flexible\n :- I want some more color options and some what more show hide kind of functionality.\n- I want user can add custom header / footer and even integrate chat option of 3rd party on this page.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "One of the most details implementation of Feature feedback system",
                    "language": null,
                    "published_at": 1628812800
                },
                {
                    "id": 5729205312,
                    "supplier": "capterra",
                    "reviewer_name": "Utsav C.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": " :Sold at first sight!. Really amazing product with good UI/UX and fulfil all my needs. I really enjoy using this product. Would love to spread love and share about it to my friends. \n :Need more functionality. Like NPS, product showcasing, etc",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Well defined. Great UI/UX",
                    "language": null,
                    "published_at": 1628035200
                },
                {
                    "id": 5729205306,
                    "supplier": "capterra",
                    "reviewer_name": "Verified Reviewer",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": " :I've been needing a simple change log for a couple of companies, with the option of adding on a feedback tool. I was set on having to hack together something with Zapier. But Sleekplan does everything I need, perfectly.  And I have the option of adding in more things (Roadmap, user satisfaction). Sleekplan has done a fantastic job of having a wide variety of options to customize, and still have the interface not feel overwhelming. Robust dashboard to get analytics of how users are interacting with the widget.\n\nI appreciate them adding the option to let users vote on feedback without needing to log in, and if they want to create an account, the password creation is handled by email. A nice touch that makes the experience feel high end for users.  Getting users to quickly add feedback and not get tangled up in account creation is A+.\n :My only feedback - and it's small - is allowing us a little more customization on the widget for the web page.  And on Wordpress, it's a little difficult to add as an attribute tag to a menu item to open the widget on click.  I had to add some custom php.  Other companies use CSS, and that was much easier for me.  BUT - this is something that is custom.  If you want to use the widget, you can just set it and forget it and it works wonderfully.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Packed features set in this niche.",
                    "language": null,
                    "published_at": 1628035200
                },
                {
                    "id": 5729205301,
                    "supplier": "capterra",
                    "reviewer_name": "Tyler J.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Overall:We gather product feedback, feature requests, and sentiment from our clients as well we are able to communicate our roadmap and product updates. Very happy to have found this app.\n :I really like how it can be embedded within your app or website. We have one workspace embedded on our client website for one of our products and another workspace embedded within one of our other products which is an online app. I also like how the app not only collects product feedback, such as feature requests or bugs (you can self-define categories), but it also prompts users within your app/website to rate your product/customer experience. Very valuable that this is integrated into the platform. I also really like how the app is fully custom branded with our own domain.\n :The one thing I would improve is being able to add users from the backend - not currently possible at the time of writing this - because some clients reach out to us directly with a feature request and we input it but then it is attributed to us not them.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "The best customer feedback and sentiment app currently on the market",
                    "language": null,
                    "published_at": 1629849600
                },
                {
                    "id": 5729205315,
                    "supplier": "capterra",
                    "reviewer_name": "Igor S.",
                    "reviewer_picture_url": "https://cdn0.capterra-static.com/profile-images/linkedin/b4e65da29e46d4827e4025f7ef9dc27d.jpeg",
                    "rating": 5,
                    "text": " :I used to have to login into a bunch of different tools to get all the feedback from my users. It makes my feedback workflow easier.\n :You can't put the roadmap as the main page by default.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Awesome tool",
                    "language": null,
                    "published_at": 1627862400
                },
                {
                    "id": 5729205300,
                    "supplier": "capterra",
                    "reviewer_name": "Jean F. Q.",
                    "reviewer_picture_url": "https://cdn0.capterra-static.com/profile-images/linkedin/4416897677c9c466f929d57d55598344.jpeg",
                    "rating": 5,
                    "text": "Overall:Seemless. Can't really say much more than that.\nInterface is clear and clean and support is outstanding.\n :It's just so easy to configure it and deploy it. The options are extensive and you'll start collecting information right away.\nNo-brainer type of platform.\n :It lacks a few features that I believe are going to be considered such as integrated context capture for bug reporting and an SDK to consolidate exceptions and other errors directly from the codebase at execution.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Possibly the best feedback loops & review platform out there.",
                    "language": null,
                    "published_at": 1630800000
                },
                {
                    "id": 5729205310,
                    "supplier": "capterra",
                    "reviewer_name": "Sorcha M.",
                    "reviewer_picture_url": null,
                    "rating": 4,
                    "text": "Overall:Sleekplan has been a great experience so far and I anticipate it will make a huge change in how we design products in the future as we continue to use it to collect customer feedback and satisfaction metrics more and more.\n :The ability to integrate customer feedback into ongoing product design is a huge benefit to the business and  the fact that it's easy to use with a clean interface is a bonus.\n :It does take awhile to get up and running because there are so many settings options but thats the tradeoff for being able to customize the experience so it's not really a downside.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "An elegant solution to the problem of customer satisfaction",
                    "language": null,
                    "published_at": 1633132800
                },
                {
                    "id": 5729205307,
                    "supplier": "capterra",
                    "reviewer_name": "Wojciech P.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Overall:Hello, I barely entered the system and it immediately became ... great! With so many offers that I have purchased to support marketing in our company, I am finally satisfied. The interface is clean clean easy to preview. The only thing that comes to my mind is when will the Polish language be available? it is a drawback of Developers that they integrate languages! In addition, 5 Taco, because probably if it goes in the right direction, it will develop into a great platform for integrating customers with the company!\nDo not hesitate, just buy because the offer is worth every cent!\n :easy to manage, clean interface and work logic on the application\n :No Polish language, developers have a very bad approach, not integrating languages",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Searching for the right software",
                    "language": null,
                    "published_at": 1627862400
                },
                {
                    "id": 5729205323,
                    "supplier": "capterra",
                    "reviewer_name": "Verified Reviewer",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": " :Honestly, the best part of Sleekplan is how helpful {SENSITIVE CONTENT] is - he's personally responded to me a number of times and is helping me get it set up with SSO. \n\nThere are a lot of tools like this, so this is how I choose Sleekplan over the other tools. \n :No major cons that I've discovered so far.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Amazing Support!",
                    "language": null,
                    "published_at": 1632268800
                },
                {
                    "id": 5729205311,
                    "supplier": "capterra",
                    "reviewer_name": "Julian W.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Overall:Great!\n :Finally the good integration: Sleekplan automatically uses the Data of the logged WP-Users so users don´t have to register on a different page and all of that terrible stuff.\n :Some parts are not as nice in usability: \"Submit\"-Button is on the top where nobody expects it, management of Team is not as easy as I would expect it, stuff like that.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Great Software",
                    "language": null,
                    "published_at": 1634428800
                },
                {
                    "id": 5729205326,
                    "supplier": "capterra",
                    "reviewer_name": "Amar V.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": " :Simple and clean design. No messing around, clean interface. \n :The survey feature isn't robust, but I did not get it for that. It is a nice add-on though.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Intuitive",
                    "language": null,
                    "published_at": 1629072000
                },
                {
                    "id": 5729205308,
                    "supplier": "capterra",
                    "reviewer_name": "Verified Reviewer",
                    "reviewer_picture_url": "https://cdn0.capterra-static.com/profile-images/linkedin/39214995ecefca023e314a3b8b2a743e.jpeg",
                    "rating": 5,
                    "text": "Overall:We're an early startup, so gathering feedback is critical for us at this stage. Sleekplan allows us to do this fast, \n :The UI is amazing, backend and customer facing. It has EXACTLY everything you need to manage feedback.\n :The only con I could possibly think of would be that they don't ship the widget in Dutch. However they've fixed this by allowing custom input for each field, so its not really a con.",
                    "url": "https://www.capterra.com/p/232766/Sleekplan/",
                    "title": "Exactly what I was looking for",
                    "language": null,
                    "published_at": 1631232000
                },
                {
                    "id": 3950911051,
                    "supplier": "g2",
                    "reviewer_name": "Administrator in Commercial Real Estate",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "The UI is amazing. Next to that they allow us to use our own text in the widget, which for us was a huge factor when chosing Sleekplan. There is nothing that I dislike about Sleekplan As a startup we really need to act fast on customer feedback. With Sleekplan our customers are just 1 click away!  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4997180",
                    "title": "\"Exactly what we needed\"",
                    "language": null,
                    "published_at": 1631232000
                },
                {
                    "id": 3950911046,
                    "supplier": "g2",
                    "reviewer_name": "Gene D.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Sleekplan is an all-in-one feedback loop management tool that I've grown to love as I use it. I can collect feedback from my audience, prioritize feature requests, discuss ideas with my team, set up release reminders, and create release notes, all of which are crucial to growing my business. My audience loves hearing about what's new, and Sleekplan helps me provide this information in a way that's easy to digest and keeps them engaged. Also, it allows me to implement the features as a widget (unlimited use), website (limited) and as an iframe. This gives me flexibility depending on the customers' needs. If I want to implement it as a website, I have a limited number of workspaces and that's the only thing I dislike about it. Collecting feedback from users is a vital part of the growth of my products and company. The happiness of users is first and foremost to our goal.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-5017701",
                    "title": "\"One of the Best Tools of its Kind!\"",
                    "language": null,
                    "published_at": 1632355200
                },
                {
                    "id": 3950911054,
                    "supplier": "g2",
                    "reviewer_name": "Muhammad K.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Want to gather instant feedback from your customers? Here's the tool to rule them all. It's like an entire website is embedded into a neat widget. The UI/UX is out of this world! Very happy with the purchase and the founder is extremely supportive...Highly recommended deal! Out of the box, the plan supports just 1 domain. It will be nice if there was support for atleast 5 domains in the basic plan Have started using this for my Power BI dashboards to gather user-feedback as well as ideas and suggestions for improvement.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4988848",
                    "title": "\"The real deal!\"",
                    "language": null,
                    "published_at": 1630886400
                },
                {
                    "id": 3950911069,
                    "supplier": "g2",
                    "reviewer_name": "Administrator in Computer Software",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Moving from the Traditional Boards and Feedback Logs, SleekPlan has some new concepts and can show user-specific updates and changelogs. A promising roadmap and speedy development makes them an excellent alternative to other Feedback Boards. Nothing as of Now. Since the People at SleekPlan are ready to take feedback and work on them progressively. Changelogs , Product Feedbacks and User Ideas Collection  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4899617",
                    "title": "\"A Clean Sleeky Alternative to regular Feedback Boards\"",
                    "language": null,
                    "published_at": 1627516800
                },
                {
                    "id": 3950911066,
                    "supplier": "g2",
                    "reviewer_name": "Administrator in Design",
                    "reviewer_picture_url": null,
                    "rating": 4.5,
                    "text": "Really impressed with the core features that allow us to connect with our customers - mainly via the feedback / suggestions board (which allows for up and downvoting) but also make use of the roadmap and changelog features. The UI/UX is top notch too. Not blown away with the current survey tool though I know this is new and may be developed further. Is very simple as is. Superb all-in-one tool to engage with your customer base. Connecting and engaging with customers is really important to us as is involving them in the direction that my product will take. Sleekplan gives me the tools that I need to do this.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4903748",
                    "title": "\"Powerful and flexible tool\"",
                    "language": null,
                    "published_at": 1627776000
                },
                {
                    "id": 3950911057,
                    "supplier": "g2",
                    "reviewer_name": "Larry W.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "I like the ease of use, how easy I can add to multiple websites, and of course, the analytics are amazing overall just a powerful tool  for client feedback Well More 3rd  native integrations i would love to see. and  both in and out webhooks This is an absolute no-brainer. Buy a subscription to sleek plan and see your bottom line go through the roof!! WE can now get live feedback questions and changes instantly - So helpful in theses times  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4971275",
                    "title": "\"FEED BACK KING\"",
                    "language": null,
                    "published_at": 1630022400
                },
                {
                    "id": 3950911060,
                    "supplier": "g2",
                    "reviewer_name": "Jeremy B.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Sleekplan is super simple to set up and install. From there it takes care of all my customer satisfaction needs There is nothing to dislike at this stage Customer feedback, roadmap and chanelog  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4954160",
                    "title": "\"great little app\"",
                    "language": null,
                    "published_at": 1629331200
                },
                {
                    "id": 3950911059,
                    "supplier": "g2",
                    "reviewer_name": "Tomas S.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Visual analytics modul, user segmentation, simplicity. subscription to roadmap updates Some UI could be improved, but this is matter of time. This professional feedback collecting web app saved us a lot of monay. It helped us to collect a lot of ideas from our users and prioritize them the right way.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4966084",
                    "title": "\"Simple and affordable feedback collecting app offering everything we need\"",
                    "language": null,
                    "published_at": 1629849600
                },
                {
                    "id": 3950911071,
                    "supplier": "g2",
                    "reviewer_name": "嘉祥 .",
                    "reviewer_picture_url": "https://images.g2crowd.com/uploads/avatar/image/489294/thumb_square_87a4a4e51258e74cc24d81a66adcbfec.jpeg",
                    "rating": 5,
                    "text": "I like the ability to have feedback, roadmaps, and change log. It’s a very good combination. Currently does not support Chinese user interface. I hope to provide more functions to users. I have an idea. Combining  own chat function is the best! The founder solved the user interface problem in traditional Chinese, making it easier for us Chinese to use.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4893297",
                    "title": "\"This is a huge deal\"",
                    "language": null,
                    "published_at": 1627344000
                },
                {
                    "id": 3950911062,
                    "supplier": "g2",
                    "reviewer_name": "User in Photography",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Sleekplan does everything perfectly, with more room to grow. They've done a fantastic job of having a wide variety of customization options, and still have the interface not feel overwhelming. They also include a robust dashboard to get analytics of how users interact with the widget without needing to use gAnalytics or another service.   I appreciate the addition of letting users vote on feedback without needing to log in. And if they want to create an account, the password creation/login is handled through an emailed code. A nice touch that makes the experience feel high-end for users and gets them submitting feedback rather than trying to get an account created. I would like more customization in the widget. It's beautiful as-is, but it would be nice to give it a little more flare to feel like it's designed as a part of the website. Try the very generous trial and compare it to other options out there.  The amount of features you get at this price point is incredible. The customer feedback cycle is something that we've been using multiple services for.  Sleekplan integrates it into one simple solution with a data-rich interface.  We can spend more time reacting to feedback and less time trying to gather it.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4911752",
                    "title": "\"Everything You Need For Customer Feedback Cycles.\"",
                    "language": null,
                    "published_at": 1628035200
                },
                {
                    "id": 3950911072,
                    "supplier": "g2",
                    "reviewer_name": "Hemant S.",
                    "reviewer_picture_url": null,
                    "rating": 4.5,
                    "text": "It is a holistic solution that integrates many facets of a project or product development process and brings it to one central place. It replaces a few other apps in the process and for me, it saves time as well as mental space between switching tasks and apps. As of 07/2021 it is not yet fully optimized for mobile devices Centralised work space for:Feedback BoardChangelogRoadmapCSAT-SurveysUser databaseThe widget is aesthetically pleasing and matches with brand colours. Gives user confidence and doesn't feel like a forcefit. As mentioned, the biggest benefit would be the time saved from task switching between apps as this replaces two apps I was using.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4893353",
                    "title": "\"The feedback loop  in one place\"",
                    "language": null,
                    "published_at": 1627344000
                },
                {
                    "id": 3950911061,
                    "supplier": "g2",
                    "reviewer_name": "Baptiste A.",
                    "reviewer_picture_url": "https://images.g2crowd.com/uploads/avatar/image/505890/thumb_square_3be6200ccae6daf3159524a71f2985e8.jpeg",
                    "rating": 4,
                    "text": "The fact that I set up a feature request page in 5 minutes with custom brand color and custom domain. Some settings are sometimes difficult to find My users can now propose features on their own and the votes will automatically arrange the features list  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4929693",
                    "title": "\"Perfect product feedback tool\"",
                    "language": null,
                    "published_at": 1628726400
                },
                {
                    "id": 3950911056,
                    "supplier": "g2",
                    "reviewer_name": "Jean F. Q.",
                    "reviewer_picture_url": null,
                    "rating": 4.5,
                    "text": "It's just so easy to configure it and deploy it. The options are extensive and you'll start collecting information right away.No-brainer type of platform. It lacks a few features that I believe are going to be considered such as integrated context capture for bug reporting and an SDK to consolidate exceptions and other errors directly from the codebase at execution. Feedback loops & reviews + consolidating error tracking on codebase during execution.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4987942",
                    "title": "\"Possibly the best feedback loops & review platform out there.\"",
                    "language": null,
                    "published_at": 1630800000
                },
                {
                    "id": 3950911064,
                    "supplier": "g2",
                    "reviewer_name": "Igor P.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "I have a lot of people who need to be able to give feedback on the website I'm building and without a proper way to capture all of this feedback, it's hard to keep track of what needs to be done. I found Sleekplan and it was the perfect solution to my problem. I can quickly set up a feedback widget to a specific page on my website and get feedback directly from my users. It's so easy to use, I can get up and running in a matter of minutes. One can't add the roadmap as the main page by default. Feedback, roadmap, and changelog.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4905610",
                    "title": "\"Awesome investment!\"",
                    "language": null,
                    "published_at": 1627862400
                },
                {
                    "id": 3950911053,
                    "supplier": "g2",
                    "reviewer_name": "Alex M.",
                    "reviewer_picture_url": "https://images.g2crowd.com/uploads/avatar/image/439937/thumb_square_05be56d841efc41b5b531fb282edd6ac.jpeg",
                    "rating": 4.5,
                    "text": "My favorite thing about Sleekplan is that my customers have a place to provide suggestions and I have a place to collect their feedback. This is incredibly valuable to me. The feedback board is very easy to use and helps prioritize ideas so I can improve my product. This insight ultimately helps me shape my business and cater to my customers more effectively. Because I use Sleekplan as a simple solution to collect customer suggestions, there isn't much for me to dislike. Sleekplan is easy to set up and it works as I need it to. When your customers do not have a place to provide constructive feedback, they do not feel you are listening. Sleekplan provides me with a systematic way to collect my customers' suggestions and make them feel heard. Then, I can use those suggestions at the top of the list (upvoted) to make my product better.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4995531",
                    "title": "\"Sleekplan is a Win-Win\"",
                    "language": null,
                    "published_at": 1631145600
                },
                {
                    "id": 3950911042,
                    "supplier": "g2",
                    "reviewer_name": "User in Entertainment",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "The simplicity of it. I was able to quickly set up a feature request widget for my website that was highly customised to my business within a few minutes. The whole process was very smooth as the UI was initutive and load times were fast. Once set up, the widget helps me collect feedback from my users and provides them with a way to vote on the features they want the most. This significantly simplifies things for my team, as we essentially let the users decide what features to release next. The tool even gives us reminders. The tool also enables two-way interaction via the roadmap and changelog feature, which allows us to keep our users in the loop. This does wonders for building up a strong customer relationship.Some other features I found very useful include allowing users to vote without having to log in, and the dashboard which lets me see how the users interact with the widget. There is not much for me to dislike with Sleekplan. It does its job and then some. I believe that a strong relationship with clients is key to business success, and Sleekplan facilitates this. It allows my clients to feel like they are being listened to, and we also know that our updates are what customers want. So it is pretty much killing 2 birds with 1 stone.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-5041822",
                    "title": "\"Everything you need to set up an effecient and effective feedback loop\"",
                    "language": null,
                    "published_at": 1633478400
                },
                {
                    "id": 3950911063,
                    "supplier": "g2",
                    "reviewer_name": "Consultant in Marketing and Advertising",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "Sold at first sight!. Really fantastic product with good UI/UX and fulfill all my needs. I enjoy using this product. I would love to spread love and share it with my friends. Need more features like - Product showcasing and NPS Feedback collection, User love rate, and feature request.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4911924",
                    "title": "\"Great Product. Amazing UI/UX\"",
                    "language": null,
                    "published_at": 1628035200
                },
                {
                    "id": 3950911067,
                    "supplier": "g2",
                    "reviewer_name": "Harshal K.",
                    "reviewer_picture_url": "https://images.g2crowd.com/uploads/avatar/image/363655/thumb_square_2c8f98aa3ed76a2848b0bc9ba21ce8c9.jpeg",
                    "rating": 5,
                    "text": "I loved the simple interface and sleek page for announcing features & collecting feedback.Almost every area can be customised.Widget looks cool and it's easy to integrate. We tried iframe and that looked great too.Support is super responsive. There is hardly anything to dislike. Everything is perfect at this price and for this use case. We use Sleekplan to announce features, collect suggestions and feedback.This has increased the engagement of our users.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-4901380",
                    "title": "\"Sleek way to announce features & collect feedback\"",
                    "language": null,
                    "published_at": 1627603200
                },
                {
                    "id": 3950911044,
                    "supplier": "g2",
                    "reviewer_name": "Sorcha M.",
                    "reviewer_picture_url": null,
                    "rating": 5,
                    "text": "I love that I have so much control with Sleekplan - having the different types of modules available in one software is so helpful. The feedback and customer satisfaction modules are exactly what I need for my new membership and it's a bonus to have the option of a changelog too. So far my experience has been very good. The interface is laid out intuitively, it's fast to load, and everything is very simple to use. There are so many settings that it's not a super quick set up - but that's a small downside given those settings allow me to customize the software to my needs. I run a membership site and getting customers to engage and share what they want to see next or how they feel about content can be a challenge. Sleekplan is helping me to gather more feedback without having to reach out to each person individually.  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-5035844",
                    "title": "\"An elegant, easy to use interface with a comprehensive set of features\"",
                    "language": null,
                    "published_at": 1633132800
                },
                {
                    "id": 3950911040,
                    "supplier": "g2",
                    "reviewer_name": "Julian W.",
                    "reviewer_picture_url": null,
                    "rating": 4.5,
                    "text": "Finally a product which integrates Wordpress with Single-Sign-On. So my (logged) users don´t need to register on a third software when giving a Feedback or want to vote on a Feature-Request! Some of the usability-stuff, for example the \"Submit-Button\" which is on the top of the widget instead of on the bottom right where everybody would expect it. Feedback and Feature-Requests without re-registering  ",
                    "url": "https://www.g2.com/products/sleekplan/reviews/sleekplan-review-5061875",
                    "title": "\"Great Software, mostly because of the Wordpress-Integration\"",
                    "language": null,
                    "published_at": 1634428800
                }
            ],
        }

    },


    /** ----------------------------------------------------
     * View => Computed
     ----------------------------------------------------- */
    computed: {

        loaded_testimonials() {
            return this.get_testimonials();
        },

    },


    /** ----------------------------------------------------
     * View => Methods
     ----------------------------------------------------- */
    methods: {

        get_testimonials() {

            var array = this.testimonials;
            let currentIndex = array.length,  randomIndex;

            // While there remain elements to shuffle...
            while (currentIndex != 0) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;

                // And swap it with the current element.
                [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
            }

            var len = 3;

            var chunks = [], 
            i = 0, 
            n = array.length;

            while (i < n) {
                chunks.push(array.slice(i, i += len));
            }
            return chunks;
            
        },

        shuffle_initial_logos() {
            const shuffled = [...this.companies].sort(() => 0.5 - Math.random());
            this.visible_logos = shuffled.slice(0, 8);
            this.hidden_logos = shuffled.slice(4);
        },

        fade_before_enter(el) {
            el.style.opacity = 0;
        },

        fade_enter(el, done) {
            el.offsetHeight; // trigger reflow
            el.style.transition = 'opacity .5s';
            el.style.opacity = 1;
            done();
        },

        fade_leave(el, done) {
            el.style.transition = 'opacity .5s';
            el.style.opacity = 0;
            // Ensure that the element is removed only after the transition ends
            setTimeout(() => {
                done();
                this.$set(this.visible_logos, this.fade_visibleIndex, { img: this.fade_newLogo.img, key: this.fade_oldLogo.key });
                // Update hidden_logos after fade out completes
                this.hidden_logos.splice(this.hidden_logos.indexOf(this.fade_newLogo), 1, this.fade_oldLogo);
                // Reset flag after the animation
                this.fading_out = false;
            }, 500); // 2 seconds to match the fade duration
        },

        fade_out_logo() {

            if (this.fading_out) return; // Prevent overlapping transitions

            this.fading_out = true;

            // If the replacement_queue is empty, refill and shuffle it
            if (this.replacement_queue.length === 0) {
                this.prepareReplacement_queue();
            }

            // Get the next logo index to replace
            const visibleIndex = this.replacement_queue.pop();

            // Create a placeholder during the fade-out
            const oldLogo = this.visible_logos[visibleIndex];
            this.$set(this.visible_logos, visibleIndex, { img: null, key: oldLogo.key });

            // Filter hidden_logos to ensure no duplicates
            const availableLogos = this.hidden_logos.filter(
                (hiddenLogo) => !this.visible_logos.some((visibleLogo) => visibleLogo.img === hiddenLogo.img)
            );

            if (availableLogos.length === 0) {
                this.fading_out = false;
                return;
            }

            // Pick a random hidden logo to replace the visible one
            const hiddenIndex = Math.floor(Math.random() * availableLogos.length);
            const newLogo = availableLogos[hiddenIndex];

            // Fade out the old logo and fade in the new one
            this.fade_visibleIndex = visibleIndex;
            this.fade_oldLogo = oldLogo;
            this.fade_newLogo = newLogo;

        },

        // Shuffle visible logos to replace each one sequentially
        prepareReplacement_queue() {
            this.replacement_queue = Array.from({ length: this.visible_logos.length }, (_, i) => i);

            // Shuffle the replacement queue to ensure random replacements
            for (let i = this.replacement_queue.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [this.replacement_queue[i], this.replacement_queue[j]] = [this.replacement_queue[j], this.replacement_queue[i]];
            }
        },

	},


    /** ----------------------------------------------------
     * View => On Mount
     ----------------------------------------------------- */
    mounted() {

        //var my_awesome_script = document.createElement('script');
        //my_awesome_script.setAttribute('src','https://apps.elfsight.com/p/platform.js');
        //document.head.appendChild(my_awesome_script);

        // add class
        this.$parent.$refs['home-header'].menu_transparent = true;
        this.$parent.$refs['home-header'].logo = this.logo_white;

        // Initially show 4 random logos
        this.shuffle_initial_logos();
        
        // Start the shuffling process every 2 seconds
        this.interval_id = setInterval(this.fade_out_logo, 2000);
          
    },


    /** ----------------------------------------------------
     * View => On Destroyed
     ----------------------------------------------------- */
    destroyed() {

        // remove class
        this.$parent.$refs['home-header'].menu_transparent = false;
        this.$parent.$refs['home-header'].logo = this.logo_default;

        // Clear the interval when the component is destroyed
        clearInterval(this.interval_id);

    },


    /** ----------------------------------------------------
     * Header
     ----------------------------------------------------- */
    head: {
        // Meta title
        title: {
            inner: 'Customers',
            separator: '|',
            complement: 'Sleekplan'
        },
        // Meta tags
        meta: [
            { 
                name: 'description', 
                content: '', 
                id: 'desc' 
            },
            { name: 'robots', content: 'index,follow' },
        ],
        // Link tags
        link: [
            { 
                rel: 'canonical', 
                href: 'https://sleekplan.com' + location.pathname, 
                id: 'canonical' 
            },
        ]
    }


}
</script>